/* eslint-disable no-return-await */
import jwtDecode from 'jwt-decode'
import axios from 'services/axiosBase'
import { toast } from 'react-toastify'
import { logout } from 'redux/auth/actions'
import { store } from 'redux/store'
import history from 'utils/history'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'

export const baseUrl = process.env.REACT_APP_KYE_API

const service = async (
  method,
  url,
  token,
  data = null,
  params = null,
  location = null,
  signal = null,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
  responseType = undefined,
  accept = undefined,
  publicEndpoint = false,
  withCredentials = false,
  withAuthroizationHeader = true,
) => {
  if (!token && !publicEndpoint) {
    logout()
    return history.push({
      pathname: '/login',
      state: {
        from: location,
      },
    })
  }

  if (token) {
    const decoded = jwtDecode(token)
    const current_time = Date.now() / 1000

    if (decoded.exp < current_time) {
      toast.error('Seu acesso expirou, faça login novamente.')
      logout()
      return history.go({
        pathname: '/login',
        state: { from: location },
      })
    }
  }
  try {
    // Let the browser/axios set Content-Type (with boundary) for FormData bodies
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData

    const headers = {
        ...(isFormData ? {} : { 'Content-Type': contentType }),
        'Accept': accept,
        'X-Request-Origin': 'PANEL',
        Authorization: `Bearer ${token}`,
    }

    if (withAuthroizationHeader) {
      headers.Authorization = `Bearer ${token}`
    }

    const res = await axios({
      method: method,
      url: `${baseUrl}${url}`,
      headers: headers,
      responseType: responseType,
      crossDomain: true,
      params,
      data: data,
      signal: signal,
      withCredentials: withCredentials,
    })
    return res.data
  } catch (error) {
    if (throwErrors || (signal && signal.aborted)) {
      throw error
    }

    if (quiet) {
      console.error(error)
      return null
    }

    if (error.response) {
      if (error.response.status === 401 && error.response.data.detail === 'Invalid or expired credentials') {
        toast.warn('Acesso expirado, faça login novamente.')
        store.dispatch(logout())
        history.push({
          pathname: ROUTE_CONSTANTS.LOGIN,
          state: { from: location },
        })
      } else if (error.response.status === 500) {
        toast.error('Erro interno no servidor. Tente novamente mais tarde.')
      } else if (error.response.data.message) {
        toast.error(error.response.data.message)
      } else if (error.response.data.detail) {
        toast.error(error.response.data.detail)
      }
    } else {
      toast.error('Houve um erro ao realizar esta ação')
    }
  }
  return null
}

export const get = async ({
  url,
  token,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  responseType = undefined,
  accept = undefined,
  publicEndpoint = false,
  withCredentials = false,
  withAuthroizationHeader = true,
}) => {
  return await service('GET', url, token, null, params, location, signal, quiet, throwErrors, undefined, responseType, accept, publicEndpoint, withCredentials, withAuthroizationHeader)
}

export const post = async ({
  url,
  token,
  data,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
  publicEndpoint = false,
  withCredentials = false,
  withAuthroizationHeader = true,
}) => {
  return await service('POST', url, token, data, params, location, signal, quiet, throwErrors, contentType, undefined, undefined, publicEndpoint, withCredentials, withAuthroizationHeader)
}

export const put = async ({
  url,
  token,
  data,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
  publicEndpoint = false,
  withCredentials = false,
  withAuthroizationHeader = true,
}) => {
  return await service('PUT', url, token, data, params, location, signal, quiet, throwErrors, contentType, undefined, undefined, publicEndpoint, withCredentials, withAuthroizationHeader)
}

export const patch = async ({
  url,
  token,
  data,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
  publicEndpoint = false,
  withCredentials = false,
  withAuthroizationHeader = true,
}) => {
  return await service('PATCH', url, token, data, params, location, signal, quiet, throwErrors, contentType, undefined, undefined, publicEndpoint, withCredentials, withAuthroizationHeader)
}

export const remove = async ({
  url,
  token,
  data,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
  publicEndpoint = false,
  withCredentials = false,
  withAuthroizationHeader = true,
}) => {
  return await service('DELETE', url, token, data, params, location, signal, quiet, throwErrors, contentType, undefined, undefined, publicEndpoint, withCredentials, withAuthroizationHeader)
}
